import { AndroidFilled } from '@ant-design/icons';
import { Button, EButtonIntents } from '@devotel/design-system';
import { PageWrapper } from '@src/components/Wrapper';
import { Apple } from 'iconsax-react';

interface ChooseDeviceProps {
  onChooseDevice: (device: 'apple' | 'android') => void;
}

export function ChooseDevice({ onChooseDevice }: Readonly<ChooseDeviceProps>) {
  return (
    <PageWrapper rootClassName='bg-wl-background text-wl-on-background p-4 space-y-4'>
      <p>Select the type of device you will be installing this eSIM on.</p>
      <Button
        className='w-full !bg-wl-surface !text-wl-on-background'
        intent={EButtonIntents.Linear}
        onClick={() => onChooseDevice('apple')}
      >
        <div className='flex justify-between w-full'>
          <span>IOS</span> <Apple variant='Bold' />
        </div>
      </Button>
      <Button
        className='w-full !bg-wl-surface !text-wl-on-background'
        intent={EButtonIntents.Linear}
        onClick={() => onChooseDevice('android')}
      >
        <div className='flex justify-between w-full'>
          <span>Android</span>
          <AndroidFilled style={{ fontSize: '20px', color: '#69af69' }} />
        </div>
      </Button>
    </PageWrapper>
  );
}
